import { SectionCompletion, SectionId } from '../model/Profile.types';
import { ProfileFormValues } from './Profile.schema';

const isTextFilled = (value: string | null | undefined): boolean =>
  typeof value === 'string' && value.trim().length > 0;

const isMediaFilled = (value: unknown): boolean =>
  value !== null && value !== undefined;

const isColorSet = (value: string | undefined): boolean =>
  typeof value === 'string' && value.length > 0;

const hasKeywords = (value: string[] | undefined): boolean =>
  Array.isArray(value) && value.length > 0;

type FieldCheck = (values: ProfileFormValues) => boolean;

const sectionFields: Record<SectionId, FieldCheck[]> = {
  identity: [
    (v) => isMediaFilled(v.mediaAvatar),
    (v) => isMediaFilled(v.mediaCover),
    (v) => isColorSet(v.customColorSchema?.primaryColor),
    (v) => isTextFilled(v.firstName),
    (v) => isTextFilled(v.lastName),
    (v) => isTextFilled(v.title),
    (v) => v.gender !== null && v.gender !== undefined,
  ],
  story: [
    (v) => isTextFilled(v.messageProfile),
    (v) => isTextFilled(v.accomplishments),
    (v) => isTextFilled(v.profileInstagram),
    (v) => isTextFilled(v.profileTiktok),
    (v) => isTextFilled(v.profileYoutubeChannel),
  ],
  media: [
    (v) => isMediaFilled(v.mediaBanner),
    (v) => isMediaFilled(v.mediaWelcome),
  ],
  discovery: [(v) => hasKeywords(v.keywords)],
};

export const calculateSectionCompletion = (
  sectionId: SectionId,
  values: ProfileFormValues,
): SectionCompletion => {
  const checks = sectionFields[sectionId];
  const totalFields = checks.length;
  const filledFields = checks.filter((check) => check(values)).length;
  const percentage =
    totalFields > 0 ? Math.round((filledFields / totalFields) * 100) : 0;

  return {
    sectionId,
    filledFields,
    totalFields,
    percentage,
  };
};

export const calculateAllCompletions = (
  values: ProfileFormValues,
): Record<SectionId, SectionCompletion> => ({
  identity: calculateSectionCompletion('identity', values),
  story: calculateSectionCompletion('story', values),
  media: calculateSectionCompletion('media', values),
  discovery: calculateSectionCompletion('discovery', values),
});
